import script from "./TreeNode.vue?vue&type=script&setup=true&lang=js"
export * from "./TreeNode.vue?vue&type=script&setup=true&lang=js"

import "./TreeNode.vue?vue&type=style&index=0&id=bf8f8a5c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf8f8a5c"]])

export default __exports__